const apiSocket = process.env.REACT_APP_API_SERVER_ADDRESS;

export default {
  restApiHost: `https://${apiSocket}/`,
  secretKey: process.env.REACT_APP_PASSWORD_SECRET_KEY,
};
